<template>
  <div>
    <div class="hccertificate-card">
      <div
        :class="{
          'certificate-card-badge-normal': info.tcCValidity === 1,
          'certificate-card-badge-warning': info.tcCValidity === 2,
          'certificate-card-badge-invalid': info.tcCValidity === 3
        }"
      >
        {{ getValidityText }}
      </div>

      <div class="certificate-card-photo">
        <img :src="info.imgUrl" alt="" />

        <img :src="info.hcQRCode" alt="" />
      </div>

      <div class="certificate-card-info">
        <div class="certificate-card-info-title">
          <p>从&nbsp;业&nbsp;人&nbsp;员&nbsp;培&nbsp;训&nbsp;证&nbsp;明</p>
        </div>

        <div class="flex-row-whole certificate-card-info-detail">
          <p>
            <span class="field-name">编&#12288;&#12288;号</span>
            {{ info.TrainCode }}
          </p>
        </div>

        <div class="flex-row-whole certificate-card-info-detail">
          <p>
            <span class="field-name">姓&#12288;&#12288;名</span>
            {{ info.employeeName }}
          </p>
        </div>

        <div class="flex-row-whole certificate-card-info-detail">
          <p class="flex-row-half">
            <span class="field-name">性&#12288;&#12288;别</span>
            {{ info.employeeSex === 1 ? '男' : '女' }}
          </p>
          <p class="flex-row-half">
            <span class="field-name">年&#12288;&#12288;龄</span>
            {{ info.age }}
          </p>
        </div>
        <div class="flex-row-whole certificate-card-info-detail">
          <p style="display: flex">
            <span class="field-name field-name-special">培训机构</span>
            <span>{{ info.companyName }}</span>
          </p>
        </div>
        <div class="flex-row-whole certificate-card-info-detail">
          <p>
            <span class="field-name">有效日期</span>
            {{ info.validityBeginDate }} 至 {{ info.validityEndDate }}
          </p>
        </div>
      </div>

      <!-- <div class="image"> -->
      <!-- <img src="../svg/jk_img_bg.png" alt="" class="image"> -->
      <!-- </div> -->
    </div>

    <!-- <div v-if="info.personal" class="description" :class="{'type1': info.tcCValidity === 1, 'type2': info.tcCValidity === 2, 'type3': info.tcCValidity === 3}">
      从业人员培训证明 {{getValidityText}}
    </div> -->
  </div>
</template>

<script>
export default {
  props: ['tCertificateInfo'],
  data () {
    return {
      info: {
        tcCValidity: Number, // 1：有效 2：快过期 3：无效
        TrainCode: '',
        employeeName: '',
        employeeSex: Number,
        age: Number,
        companyName: '',
        validityBeginDate: '',
        validityEndDate: '',
        personal: Boolean,
        imgUrl: ''
      }
    }
  },
  created () {
    this.info = Object.assign(this.info, this.tCertificateInfo)
  },
  computed: {
    getValidityText () {
      if (this.info.tcCValidity === 1) return '有效'
      else if (this.info.tcCValidity === 2) return '快过期'
      else return '已过期'
    }
  }
}
</script>

<style lang="less" scoped>
.hccertificate-card {
  .flex-row() {
    display: flex;
    align-items: flex-start;
  }

  .flex-column() {
    display: flex;
    flex-flow: column;
    align-items: flex-start;
  }

  overflow: hidden;
  position: relative;
  margin: 15px;
  padding: 15px 20px;
  border-radius: 7.5px;
  border: 1px solid #0e77ca;
  background-color: #fff;
  box-shadow: 2.5px 2.5px 2.5px rgba(191, 191, 191, 0.5);
  height: 165px;
  //background-image: url("/static/img/bg.jpg");
  .flex-row;

  .image {
    position: absolute;
    left: 0px;
    right: 0px;
    bottom: 0;
    width: 100%;
    img {
      width: 100%;
      // margin: 0 1px;
    }
  }

  .certificate-card-badge() {
    position: absolute;
    font-size: 12px;
    height: 18px;
    line-height: 18px;
    top: 40px;
    width: 82.5px;
    text-align: center;
    color: #fff;
    right: 0;
    transform: rotate(45deg);
    transform-origin: right bottom;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
  }

  .certificate-card-badge-normal {
    .certificate-card-badge;
    background-color: #00a854;
  }

  .certificate-card-badge-warning {
    .certificate-card-badge;
    background-color: #f56a00;
  }

  .certificate-card-badge-invalid {
    .certificate-card-badge;
    background-color: #f04134;
  }

  .certificate-card-photo {
    margin: 20px 20px 0 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    img:first-child {
      width: 60px;
    }

    img:last-child {
      margin-top: 1px;
      width: 65px;
      z-index: 99;
    }
  }

  .certificate-card-info {
    flex-grow: 1;
    .flex-column;
    overflow: hidden;

    p {
      margin: 0 0 3px;
      // overflow: hidden;
      // white-space: nowrap;
      // text-overflow: ellipsis;
    }

    .certificate-card-info-title {
      font-size: 19px;
      color: #007b43;
      margin: 10px 0 17px 0;
    }

    .certificate-card-info-detail {
      font-size: 12px;

      .field-name {
        color: #007b43;
        margin-right: 4px;
      }
    }
  }
}

.description {
  text-align: center;
  font-size: 18px;
  margin: 11px 0 0;
}

.type1 {
  color: #00a854;
}

.type2 {
  color: #f56a00;
}

.type3 {
  color: #f04134;
}

.field-name-special {
  min-width: 50px;
}
</style>
